export default function navigateToURL(url) {
  if (typeof window !== 'undefined' && !!url) {
    window.open(url,"_self");
  }
}
